import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Input } from './ui/input';
import { Button } from './ui/button';
import { toast } from './ui/use-toast';
import { API_BASE_URL } from '../config';
import { FUNCTION_NAMES } from '../constants';
import { fetchWithRetry } from '../utils/tourUtils';

const Signup = () => {
  const [form, setForm] = useState({
    email: '',
    password: '',
    phone: '',
    firstNameEn: '',
    lastNameEn: '',
    firstNameHe: '',
    lastNameHe: '',
  });

  const navigate = useNavigate();

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const validateForm = () => {
    const { email, password, phone, firstNameEn, lastNameEn, firstNameHe, lastNameHe } = form;

    if (!email || !/^\S+@\S+\.\S+$/.test(email)) {
      toast({ title: 'Invalid email format' });
      return false;
    }

    if (!password || password.length < 6 || password.length > 16) {
      toast({ title: 'Password must be 6-16 characters' });
      return false;
    }

    if (!phone || !/^\d{7,15}$/.test(phone)) {
      toast({ title: 'Phone must be numeric (7-15 digits)' });
      return false;
    }

    if (!firstNameEn || !lastNameEn || !firstNameHe || !lastNameHe) {
      toast({ title: 'All name fields are required' });
      return false;
    }

    return true;
  };

  const handleSubmit = async e => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      await fetchWithRetry({
        url: `${API_BASE_URL}/auth/signup`,
        throwError: true,
        data: {
          payload: {
            data: {
              ...form,
              isActive: false,
              permissions: ['CLIENT_VIEWER'],
            },
          },
        },
        label: 'signup',
        retries: 1,
      });
      debugger;
      toast({ title: 'Signup successful! Await approval.' });
      navigate('/login');
    } catch (err) {
      toast({ title: 'Signup failed', description: err.message });
    }
  };

  return (
    <div className="max-w-md mx-auto py-12 px-4">
      <h2 className="text-2xl font-semibold mb-6 text-center">Sign Up</h2>
      <form className="space-y-4" onSubmit={handleSubmit}>
        <Input
          name="email"
          placeholder="Email"
          value={form.email}
          onChange={handleChange}
          required
        />
        <Input
          name="password"
          placeholder="Password (6-16 chars)"
          type="password"
          value={form.password}
          onChange={handleChange}
          required
        />
        <Input
          name="phone"
          placeholder="Phone"
          value={form.phone}
          onChange={handleChange}
          required
        />
        <Input
          name="firstNameEn"
          placeholder="First Name (EN)"
          value={form.firstNameEn}
          onChange={handleChange}
          required
        />
        <Input
          name="lastNameEn"
          placeholder="Last Name (EN)"
          value={form.lastNameEn}
          onChange={handleChange}
          required
        />
        <Input
          name="firstNameHe"
          placeholder="שם פרטי"
          value={form.firstNameHe}
          onChange={handleChange}
          required
        />
        <Input
          name="lastNameHe"
          placeholder="שם משפחה"
          value={form.lastNameHe}
          onChange={handleChange}
          required
        />
        <Button type="submit" className="w-full">
          Create Account
        </Button>
      </form>
    </div>
  );
};

export default Signup;
